import Radio from 'backbone.radio';
import NoAccessView from '@/views/no_access_view';

    var globalCh = Radio.channel('global');
    export default function no_access(role, link, message) {
        var view = new NoAccessView({
            role: role,
            link: link,
            message : message
        });

        // Show view in app container region
        var container_region = globalCh.request('app_layout').getRegion('container');
        container_region.show(view);
    }

